'use client';

import { ConditionalHeader } from '@/components/ConditionalHeader/ConditionalHeader';
import { NotFound } from '@/components/NotFound';

export default function NotFoundPage({ error }: { error?: Error & { digest?: string } }): React.ReactNode {
  return (
    <NotFound error={error}>
      <ConditionalHeader />
    </NotFound>
  );
}
